import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useEffect } from 'preact/hooks'
import { isFrench } from '../config' 

export default () => {
    const { response: { query }} = useAppState()

    useEffect(() => {
        nostojs(api => api.loadRecommendations())
    }, [])

    return (
        <div class="flex flex-col w-full">
            <div class="ns-noresults ns-m-0">
                <div class="ns-noresults-header">
                    {isFrench 
                        ? 'Aucun résultat trouvé pour' 
                        : 'No results found for'
                    } "{query}"</div>
                <p class="ns-noresults-text">
                    {isFrench
                        ?   'Vérifiez les fautes d&#39;orthographe, essayez un terme plus générique ou utilisez moins de mots.'
                        :   'It may help to check for spelling errors, try a more general term, or use fewer words.'
                    }
                </p>
            </div>
            <div class="nosto_element" id="searchpage-nosto-1"></div>
        </div>
    )
}
